export const getLocation = (setError, setLocation) => {
  if (!navigator.geolocation) {
    setError?.("La geolocalizzazione non è supportata dal browser");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      });
      setError?.(null);
    },
    () => {
      setError?.("Impossibile rilevare la posizione del dispositivo");
    },
    {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    }
  );
};
